var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames,style:('background:url(' + _vm.bgImage + ')'),attrs:{"id":_vm.ids,"data-parallax":"true"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }